import { pluralize } from './string'

export function dayPassedByDate(dateEnd, dateStart) {
  if (!dateEnd) {
    return null;
  }
  const realDateEnd = new Date(dateEnd);
  const realDateNow = dateStart ? new Date(dateStart) : new Date();
  const diffTime = Math.abs(realDateNow - realDateEnd);
  return Math.ceil(diffTime / (1000 * 60 * 60 * 24));
}

export const dateformat = {
  billingFormat(dateStr) {
    const date = new Date(dateStr);
    return date.toLocaleString('en-US', {
      month: 'short',
      day: 'numeric',
      year: 'numeric',
    });
  },
  short(dateStr) {
    const date = new Date(dateStr);
    return date.toLocaleString('en-GB', {
      day: '2-digit',
      year: 'numeric',
      month: 'short',
    });
  },
  successEmailFormat(dateStr) {
    const date = new Date(dateStr);
    return date.toLocaleString('en-GB', {
      day: '2-digit',
      month: 'long',
      year: 'numeric',
    });
  },
  long(dateStr) {
    const date = new Date(dateStr);
    return date.toLocaleString('en-US', {
      month: 'long',
      day: 'numeric',
      year: 'numeric',
    });
  },
  backslash(dateStr) {
    const date = new Date(dateStr);
    return date.toLocaleString('en-US', {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
    });
  },
  daysTillDate(dateStr) {
    const date = new Date(dateStr);
    const daysPassed = Math.max(1, dayPassedByDate(date));
    if (daysPassed === 0) {
      return 'today';
    }
    if (daysPassed % 7 === 0) {
      const weeksPassed = daysPassed / 7;
      return `${weeksPassed} ${pluralize('week', weeksPassed)} from now`;
    }
    return `${daysPassed} ${pluralize('day', daysPassed)} from now`;
  },
};

export function isToday(date) {
  const dateToCompare = typeof date === 'string' ? new Date(date) : date;
  const today = new Date();
  return (
    dateToCompare.toISOString().split('T')[0] ===
    today.toISOString().split('T')[0]
  );
}

export function isTodayOrLater(dateStr) {
  const date = new Date(dateStr);
  const today = new Date();

  try {
    return date.getTime() > today.getTime() || isToday(date);
  } catch {
    return false;
  }
}

export function isNew(createdAt, {days = 7} = {}) {
  return new Date() - new Date(createdAt) < 1000 * 60 * 60 * 24 * days;
}

const getHoursFormat = (hours, format) => {
  if (format === 'long') {
    if (hours > 1) {
      return 'hours';
    }
    return 'hour';
  }
  return 'h';
};

const getMinutesFormat = (minutes, format) => {
  if (format === 'long') {
    if (minutes > 1) {
      return 'minutes';
    }
    return 'minute';
  }
  return 'min';
};

export const getTimeString = (
  time,
  { hourFormat = 'short', minuteFormat = 'short' } = {}
) => {
  const mins = time % 60;
  const hours = Math.floor(time / 60);
  const hoursFormat = getHoursFormat(hours, hourFormat);
  const minutesFormat = getMinutesFormat(mins, minuteFormat);
  return `${hours ? `${hours} ${hoursFormat}` : ''}${
    mins ? ` ${mins} ${minutesFormat}` : ''
  }`;
};

export function isValidDate(d) {
  return d instanceof Date && !Number.isNaN(+d);
}
export function timestampToDate(d) {
  const createdAtDate = d.toDate?.() || new Date(d);
  return createdAtDate.toISOString();
}